{
	"content": {
		"title": "Select the materials that require declarations",
		"materialListLabel": "Material",
		"materialQuantityLabel": "Material quantity ({{unit}})",
		"availableQuantityLabel": "Available quantity ({{unit}})",
		"carbonSavingsLabel": "Carbon reductions ({{unit}} CO\u2082 eq.)"
	},
	"summary": {
		"title": "Summary",
		"declarationTypeTitle": "Declaration type",
		"customerProjectTitle": "Customer project",
		"internalProjectOrProductTitle": "Internal project / product",
		"projectReferenceTitle": "Project reference",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Quantity ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Allocatable carbon reductions ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Non-allocatable carbon reduction ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Quantity is required",
		"quantityPositive": "Please enter a positive quantity.",
		"quantityLargerThanAvailable": "Please reduce the quantity to the total available",
		"savingsRequired": "Carbon reductions is required",
		"fetchNotTransferedMaterialsError": "Failed to fetch not transfered materials"
	},
	"submitTitle": "Add to project",
	"backTitle": "Back"
}
